import fetchLoyaltyAccount from 'actions/loyalty/fetchLoyaltyAccount'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import {
  getAdvancedLoyaltyActionRewardNames,
  getLoyaltyActionRewardAppliedCountSummary,
  readLoyaltyActionRewardCelebrationSummary,
  writeLoyaltyActionRewardCelebrationSummary,
} from 'loyalty/storage/loyaltyActionRewardCelebration'
import { useEffect, useState } from 'react'

/**
 * Observes fresh action-reward catalogue data and celebrates newly applied rewards.
 * Thread result through provider, avoid re-using to avoid race conditions on local storage.
 * */
function useLoyaltyActionRewardCelebration() {
  const dispatch = useAppDispatch()
  const memberId = useAppSelector(state => state.auth.account.memberId)
  const actionRewardsData = useAppSelector(state => state.loyalty.actionRewards.data)
  const [celebratingActionNames, setCelebratingActionNames] = useState<Array<string>>([])
  const [celebrationId, setCelebrationId] = useState(0)

  useEffect(() => {
    if (!memberId || !actionRewardsData) return

    const currentSummary = getLoyaltyActionRewardAppliedCountSummary(actionRewardsData)
    const previousSummary = readLoyaltyActionRewardCelebrationSummary(memberId)
    writeLoyaltyActionRewardCelebrationSummary(memberId, currentSummary)

    if (!previousSummary) return

    const actionNames = getAdvancedLoyaltyActionRewardNames(previousSummary, currentSummary)
    setCelebratingActionNames(actionNames)
    if (actionNames.length > 0) {
      setCelebrationId(id => id + 1)
      dispatch(fetchLoyaltyAccount(undefined, { force: true }))
    }
  }, [actionRewardsData, dispatch, memberId])

  return {
    celebrationActive: celebratingActionNames.length > 0,
    celebrationId,
  }
}

export default useLoyaltyActionRewardCelebration
